import React, { useEffect, useState } from "react";
import { Navigate, Routes, Route } from "react-router-dom";
/*import Header from "./components/Header/header";
import ProtectedRoute from "./components/ProtectedRoute/protectedroute";
import Home from "./pages/Home/homepage";
import Debates from "./pages/Debates/debatespage";
import Leaderboard from "./pages/Leaderboard/leaderboardpage";
import Training from "./pages/Training/trainingpage";
import Profile from "./pages/Profile/profilepage";
import CreateDebate from "./pages/CreateDebate/createdebatepage";
import LiveDebate from "./pages/LiveDebate/livedebatepage";
import FAQ from "./pages/FAQ/faqpage";
import Login from "./pages/Login/loginpage"
import Signup from "./pages/SignUp/signuppage"
import Contact from "./pages/Contact/contactpage";
import Terms from "./pages/Terms/termspage";
import Privacy from "./pages/Privacy/privacypage";

import NotificationsPage from "./pages/NotificationsPage/notificationspage";
import DebateRoom from "./pages/DebateRoom/debateroompage";*/
import RssFeedsAdmin from "./components/admin/RssFeedsAdmin/RssFeedsAdmin";
import WizardConfigAdmin from "./components/admin/WizardConfig/WizardConfigAdmin";
import InviteJoin from "./components/DebateArena/InviteJoin/InviteJoin";
import CreateDebateWizard from "./components/DebateArena/CreateDebateWizard/CreateDebateWizard";
import ArenaView from "./components/DebateArena/ArenaView/ArenaView";
import HowItWorksAdmin from "./components/admin/HowItWorks/HowItWorksAdmin";
import AdminRoleManager from "./components/admin/AdminRoleManager/AdminRoleManager";
import CommunityRulesAdmin from "./components/admin/CommunityRulesAdmin/CommunityRulesAdmin";
import NewFeaturesAdmin from "./components/admin/NewFeaturesAdmin/NewFeaturesAdmin";
import SiteInfoAdmin from "./components/admin/SiteInfoAdmin/SiteInfoAdmin";
import ProtectedRoute from "./components/ProtectedRoute/protectedroute";
import ProfilePage from './components/ProfilePage/ProfilePage';
import LoginForm from './components/LoginForm/LoginForm';
import CookieConsent from './components/CookieConsent/CookieConsent';
import Home from './components/Home/Home';
import AboutPage from "./pages/About/AboutPage";
import Leaderboard from './components/Leaderboard/Leaderboard';
import Notifications from './components/Notifications/Notifications';
import CompleteRegistration from './components/RegistrationWizard/CompleteRegistration';
import RegistrationWizard from './components/RegistrationWizard/RegistrationWizard';
import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import { useAuth } from "./utils/AuthContext/authcontext";
import { listenForNotifications } from "./utils/fcmNotifications/fcmNotifications";
import Footer from "./components/Footer/footer";
import AppOverlay from "./utils/AppOverlay/AppOverlay";
import './App.css';
//import { auth } from "./firebase/firebase.js";
//import { useAuthState } from "react-firebase-hooks/auth";

function App() {
  //const [authUser] = useAuthState(auth);
  const { user } = useAuth();
  const [lang, setLang] = useState("en");
  
  useEffect(() => {
    listenForNotifications();
  }, []);
  
  return (
    <div className="app">
	  <div className="content"  id="ratio" >
        <Routes>
		  <Route path="/" element={<Home lang={lang} />} />
		  <Route path="/home" element={<Home lang={lang} showNow={true} />} />
		  <Route path="/about" element={<AboutPage lang={lang} />} />
          <Route path="/login" element={<LoginForm lang={lang}/>} />
		  <Route path="/profile" element={user ? <ProfilePage lang={lang} /> : <Navigate to="/login" />} />
		  <Route path="/leaderboard" element={user ? <Leaderboard lang={lang} /> : <Navigate to="/login" />} />
		  <Route path="/debates" element={user ? <ArenaView lang={lang} /> : <Navigate to="/login" />} />
		  <Route path="/createdebate" element={user ? <CreateDebateWizard lang={lang} /> : <Navigate to="/login" />} />
		  <Route path="/join" element={<InviteJoin lang={lang} currentUser={user} />} />
		  <Route path="/debates/:id" element={user ? <ArenaView lang={lang} /> : <Navigate to="/login" />} />
		  <Route path="/notifications" element={user ? <Notifications lang={lang} /> : <Navigate to="/login" />} />
		  <Route path="/profile/:tab" element={user ? <ProfilePage lang={lang} /> : <Navigate to="/login" />} />
		  <Route path="/forgot-password" element={<ForgotPassword lang={lang} />} />
		  <Route path="/forgot-password/setpassword" element={<ForgotPassword lang={lang} setpassword={true}/>} />
		  <Route path="/complete-registration" element={<CompleteRegistration lang={lang} />} />
		  <Route path="/admin/how-it-works" element={<ProtectedRoute><HowItWorksAdmin lang={lang}/></ProtectedRoute>} />
		  <Route path="/admin/adminconfigwizard" element={<ProtectedRoute><WizardConfigAdmin lang={lang}/></ProtectedRoute>} />
		  <Route path="/admin/adminrssfeeds" element={<ProtectedRoute><RssFeedsAdmin lang={lang}/></ProtectedRoute>} />
		  <Route path="/admin/adminroles" element={<ProtectedRoute><AdminRoleManager lang={lang}/></ProtectedRoute>} />
		  <Route path="/admin/community-rules" element={<ProtectedRoute><CommunityRulesAdmin lang={lang}/></ProtectedRoute>} />
		  <Route path="/admin/new-features" element={<ProtectedRoute><NewFeaturesAdmin lang={lang}/></ProtectedRoute>} />
		  <Route path="/admin/siteinfo" element={<ProtectedRoute><SiteInfoAdmin /></ProtectedRoute>} />
          {<Route path="/register/*" element={<RegistrationWizard lang={lang} />} />}
		  <Route path="*" element={<Navigate to="/" replace={true} />} />
          {/* Other routes */}
        </Routes>
	  </div>
	  <CookieConsent />
	  <AppOverlay />
      <Footer lang={lang}/>
    </div>
  );
}

export default App;